import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_add_report_configuration_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { module_id: string, report_id: string, is_active: boolean, allowed_applications: string[], restrictions: { type: string, entities: { entity: string, entity_id: number }[] }, default_file_type: $frontendTypes.Notifications.e_report_file_type, inputs_value_options: { input_id: string, options: { label: string, value: string }[] }[] }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.module_id)) {
      $missingRequiredInParams.push('\'module_id\'');
    }
    if (isNil($inParams.report_id)) {
      $missingRequiredInParams.push('\'report_id\'');
    }
    if (isNil($inParams.is_active)) {
      $missingRequiredInParams.push('\'is_active\'');
    }
    if (isNil($inParams.allowed_applications)) {
      $missingRequiredInParams.push('\'allowed_applications\'');
    }
    if (isNil($inParams.restrictions)) {
      $missingRequiredInParams.push('\'restrictions\'');
    }
    if (isNil($inParams.default_file_type)) {
      $missingRequiredInParams.push('\'default_file_type\'');
    }
    if (isNil($inParams.inputs_value_options)) {
      $missingRequiredInParams.push('\'inputs_value_options\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

